"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useColumns = void 0;
const react_intl_1 = require("react-intl");
const table_cells_1 = require("../../../../../composite/table/table-cells");
function useColumns() {
    const intl = react_intl_1.useIntl();
    return [
        {
            datakey: 'service',
            name: intl.formatMessage({
                id: 'EAS_SOAP_LOGGER_MESSAGES_COLUMN_SERVICE',
                defaultMessage: 'Služba',
            }),
            width: 150,
            CellComponent: table_cells_1.TableCells.TextCell,
            sortable: true,
            filterable: true,
        },
    ];
}
exports.useColumns = useColumns;
//# sourceMappingURL=messages-columns.js.map